<template>
    <v-container>
        <presidents-speakers :positionType="3707" :memberOrSenator="'senator'" pageHeader="true" header="Presidents"></presidents-speakers>
        <br/>
        <presidents-speakers :positionType="3699" :memberOrSenator="'senator'" header="Chairs of Committees"
            subHeader="Title changed to Deputy President and Chair of Committees on 22.10.1981."></presidents-speakers>
        <br/>
        <presidents-speakers :positionType="3698" :memberOrSenator="'senator'" header="Deputy Presidents and Chairs of Committees"></presidents-speakers>
    </v-container>
</template>
<script>
import PresidentsSpeakers from './PresidentsSpeakers.vue'

export default {
    data() {
        return {
            title: 'Presidents and Deputy Presidents'
        }
    },
    components: {
        PresidentsSpeakers
    }
}
</script>
<style scoped>
    .v-datatable {
        margin-bottom: 1rem;
    }
    h2 {
        margin-bottom: 1rem;
    }
</style>